import React, { useState } from "react";
import { Menu } from "antd";
import type { MenuProps } from "antd";
import { useLocation, Link } from "react-router-dom";
import { AppRoute } from "./routes";

type MenuItem = Required<MenuProps>["items"][number];

function convertRouteToMenuItem(
  route: AppRoute,
  basePath: string = "",
  onClose?: () => void,
  parentIcon?: React.ComponentType
): MenuItem {
  const fullPath = `${basePath}${route.url}`.replace(/\/+/g, "/");

  const IconToUse = route.icon || parentIcon; // 👈 Pass parent icon to children

  return {
    key: fullPath,
    icon: IconToUse ? React.createElement(IconToUse) : undefined,
    label: (
      <Link to={fullPath} onClick={() => onClose?.()}>
        {route.label}
      </Link>
    ),
    children: route.children?.map((child) =>
      convertRouteToMenuItem(child, fullPath, onClose, IconToUse) // 👈 pass icon down
    ),
  };
}

const AppMenu: React.FC<{ onClose?: () => void  , routes: AppRoute[]}> = ({ onClose , routes}) => {
  const location = useLocation();
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  const selectedKey = location.pathname;
  const openKeys = location.pathname
    .split("/")
    .filter(Boolean)
    .map((_, i, arr) => "/" + arr.slice(0, i + 1).join("/"));

  const items: MenuItem[] = routes?.map((route) =>
    convertRouteToMenuItem(route, "", onClose)
  );

  return (
    <>
      <Menu
        mode="inline"
        selectedKeys={[selectedKey]}
        defaultOpenKeys={openKeys}
        className="custom-menu"
        items={items}
        style={{
          height: "calc(100vh - 110px)",
          overflowX: "hidden",
          overflowY: "auto",
          width: "100%",
        }}
     />
    </>
  );
};

export default AppMenu;
